import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=62e2aaf4"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=62e2aaf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports